import { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Button } from "@/components/ui/button";

export default function UserResponseCell({ id, collection, initialValue = "" }) {
  const [value, setValue] = useState(initialValue);
  const [savedValue, setSavedValue] = useState(initialValue);
  const [editing, setEditing] = useState(!initialValue); // if no response yet → editable
  const [dirty, setDirty] = useState(false); // track if user started typing
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      const ref = doc(db, collection, id);
      await updateDoc(ref, { userResponse: value });
      setSavedValue(value);
      setEditing(false);
      setDirty(false);
    } catch (err) {
      console.error("Error updating userResponse:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <td className="px-4 py-3">
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={value}
          disabled={!editing}
          onChange={(e) => {
            setValue(e.target.value);
            setDirty(true);
          }}
          className={`border rounded px-2 py-1 text-sm w-full ${
            !editing ? "bg-gray-100 cursor-not-allowed" : ""
          }`}
          placeholder="Enter user response..."
        />

        {editing ? (
          dirty && (
            <Button
              size="sm"
              className="bg-green-600 hover:bg-green-700 text-white text-xs"
              disabled={loading}
              onClick={handleSave}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
          )
        ) : (
          <Button
            size="sm"
            variant="outline"
            className="text-xs"
            onClick={() => setEditing(true)}
          >
            Edit
          </Button>
        )}
      </div>
    </td>
  );
}
